import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import BannerValidationSchema from "../Validations/BannerValidation";
import { Padding } from "@mui/icons-material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { logDOM } from "@testing-library/react";

function BannerModal({ States, open, onClose, bannerEdit, onSuccess }) {
  const [bannerImage, setBannerImage] = useState(null);
  const [imageError, setImageError] = useState(null);
  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      name: bannerEdit?.name || "",
      image: bannerEdit?.image || "",
      url: bannerEdit?.url || "",
      priority: bannerEdit?.priority || "",
      stateId: bannerEdit?.stateId || "",
      isNational: bannerEdit?.isNational ?? "false",
      active: bannerEdit?.active ?? "true",
    },

    validationSchema: BannerValidationSchema.BannerValidationSchema,
    enableReinitialize: true,
    // on submit data send to db
    onSubmit: async (values, { resetForm }) => {
      console.log(bannerEdit?.id);
      try {
        let response;
        // If it's Edit data it will call Update api
        if (bannerEdit?.id) {
          response = await api.put(`/api/v1/banners/${bannerEdit?.id}`, values);
          console.log(values);
        }

        // Else it's Add data it will call Add api
        else {
          console.log(values);

          response = await api.post("/api/v1/banners", values);
        }
        // Show success toast
        toast.success(
          `Banner ${bannerEdit?.id ? "updated" : "added"} successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          }
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      }
    },
  });
  // Banner image upload in FTP
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const [bannerType, setBannerType] = useState("upload");
  const [imagesUrl, setImagesUrl] = useState([]);
  const [deletingImage, setDeletingImage] = useState(false);

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImageError("");
      console.log("File selected:", file.name);
    }
  };
  const handleUploadClick = async () => {
    if (!selectedFile) {
      console.log("No file selected!");
      return;
    }
    setLoadingImage(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await api.post("/api/ftp/uploadBanner", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setBannerImage(response.data.path);
      formik.setFieldValue("image", response.data.path);
      console.log("Upload success:", response.data);
      setLoadingImage(false);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
          setImageError(error.response.data.errorMessage);
          setLoadingImage(false);
        }
        console.error("Server responded with error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };
  // Delete upload image record api fetch data
  const handleDelete = async () => {
    setDeletingImage(true);
    setLoadingImage(false);
    setImageError(false);
    try {
      await api.put(`/api/ftp/delete`, { path: bannerImage });
      setBannerImage("");
      setDeletingImage(false);
      formik.setFieldValue("image", "");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Delete failed:", error);
      if (error.response.status === 400) {
        setImageError(error.response.data.errorMessage);
      }
    } finally {
      setDeletingImage(false);
    }
  };
  // Get iamge url api
  useEffect(() => {
    api
      .get("/api/ftp/getBanner")
      .then((response) => {
        setImagesUrl(response.data.files);
      })
      .catch((error) => {
        console.log("Error fecthing get api", error);
      })
      .finally(() => setLoadingImage(false));
  }, []);
  // Updating Bannertype state
  useEffect(() => {
    if (bannerEdit && Object.keys(bannerEdit).length > 0) {
      setBannerType("select");
    } else {
      setBannerType("upload");
    }
  }, [bannerEdit]);
  return (
    <>
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={MODAL_STYLES.standard}
          style={{ padding: "14px" }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {bannerEdit && Object.keys(bannerEdit).length > 0
              ? "Update Banner"
              : "Add Banner"}
          </Typography>
          <Box sx={FORM_STYLES.container}>
            <TextField
              size="small"
              label="Banner Name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              required
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl>
              <FormLabel
                component="legend"
                sx={{ color: "#66667f !important", fontWeight: 450 }}
              >
                Select Banner Image Type
              </FormLabel>

              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name="position"
                value={bannerType}
                onChange={(e) => setBannerType(e.target.value)}
              >
                <FormControlLabel
                  value="upload"
                  control={<Radio />}
                  label="Upload Image"
                />
                <FormControlLabel
                  value="select"
                  control={<Radio />}
                  label="Select Image"
                />
              </RadioGroup>
            </FormControl>
            {bannerType == "upload" ? (
              <>
                <Box sx={{ display: "flex", gap: 1, marginTop: "10px" }}>
                  <TextField
                    fullWidth
                    size="small"
                    type="file"
                    name="image"
                    inputRef={fileInputRef}
                    inputProps={{ accept: "image/*" }}
                    onChange={handleFileChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.image && Boolean(formik.errors.image)}
                  />

                  <Tooltip title="Upload image" arrow placement="top">
                    <IconButton
                      color="primary"
                      onClick={handleUploadClick}
                      size="small"
                      sx={{}}
                    >
                      <UploadFileIcon style={{ cursor: "pointer" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete image" arrow placement="top">
                    <IconButton
                      color="error"
                      onClick={() => handleDelete()}
                      size="small"
                      sx={{}}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
                {/* SHOW NOTE ONLY WHEN NO MESSAGES ARE ACTIVE */}
                {!loadingImage &&
                  !deletingImage &&
                  !imageError &&
                  !bannerImage && (
                    <Typography
                      sx={{
                        color: "#66667f",
                        fontSize: "13px",
                        fontStyle: "italic",
                      }}
                    >
                      Note: After clicking the upload button, wait until the
                      image URL appears.
                    </Typography>
                  )}

                {/* ERROR OR STATUS MESSAGES */}
                {imageError ? (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                    }}
                  >
                    {imageError}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "#66667f",
                      fontSize: "13px",
                      fontStyle: "italic",
                    }}
                  >
                    {loadingImage && " ...Uploading Image"}
                    {deletingImage && " ...Deleting Image"}
                    {!loadingImage && !deletingImage && bannerImage && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography sx={{ fontSize: "13px", color: "#666" }}>
                            Image Url: {bannerImage}
                          </Typography>

                          <Box
                            component="img"
                            src={`https://siaedutech.com/public/${bannerImage}`}
                            alt="preview"
                            sx={{
                              width: "70px",
                              borderRadius: 1,
                              border: "1px solid #ddd",
                              ml: 1,
                            }}
                          />
                        </Box>
                      </>
                    )}
                  </Typography>
                )}
              </>
            ) : (
              <FormControl
                size="small"
                fullWidth
                error={formik.touched.active && Boolean(formik.errors.active)}
                sx={{ mt: 2 }}
              >
                <InputLabel>Image URL</InputLabel>
                <Select
                  label="Image URL"
                  labelId="image-select-label"
                  id="image"
                  name="image"
                  value={formik.values.image}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.image && Boolean(formik.errors.image)}
                  helperText={formik.touched.image && formik.errors.image}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: "400px",
                        overflowY: "auto",
                      },
                    },
                  }}
                  sx={{
                    "& .MuiSelect-select": {
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    },
                  }}
                >
                  {imagesUrl.map((img, index) => (
                    <MenuItem
                      value={img}
                      key={index}
                      sx={{
                        "& .MuiSelect-select": {
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={`https://siaedutech.com/public/${img}`}
                        alt="preview"
                        sx={{
                          width: "100px",
                          borderRadius: 1,
                          border: "1px solid #ddd",
                        }}
                      />{" "}
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#555",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {img}
                      </Typography>
                    </MenuItem>
                  ))}
                </Select>

                {formik.touched.image && formik.errors.image && (
                  <FormHelperText sx={{ color: "red" }}>
                    {formik.errors.image}
                  </FormHelperText>
                )}
              </FormControl>
            )}

            <TextField
              size="small"
              label="URL"
              name="url"
              value={formik.values.url}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.url && Boolean(formik.errors.url)}
              helperText={formik.touched.url && formik.errors.url}
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl
              size="small"
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>
            <TextField
              size="small"
              label="Priority"
              name="priority"
              type="number"
              inputProps={{ min: 0 }}
              value={formik.values.priority}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.priority && Boolean(formik.errors.priority)}
              helperText={formik.touched.priority && formik.errors.priority}
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl
              size="small"
              fullWidth
              error={formik.touched.stateId && Boolean(formik.errors.stateId)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="stateId-label">State</InputLabel>
              <Select
                labelId="stateId-label"
                id="stateId"
                name="stateId"
                value={formik.values.stateId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="State"
              >
                {/* Example state options */}
                {States.map((state) => {
                  return (
                    <MenuItem key={state.id} value={state.id}>
                      {state.name}
                    </MenuItem>
                  );
                })}

                {/* Replace with dynamic states as needed */}
              </Select>
              {formik.touched.stateId && formik.errors.stateId && (
                <FormHelperText>{formik.errors.stateId}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              size="small"
              fullWidth
              error={
                formik.touched.isNational && Boolean(formik.errors.isNational)
              }
              sx={{ mt: 2 }}
            >
              <InputLabel id="isNational-label">Is National</InputLabel>
              <Select
                labelId="isNational-label"
                id="isNational"
                name="isNational"
                value={formik.values.isNational}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Is National"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.isNational && formik.errors.isNational && (
                <FormHelperText>{formik.errors.isNational}</FormHelperText>
              )}
            </FormControl>
            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button type="submit" {...BUTTON_STYLES.primary}>
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default BannerModal;
